export enum SeedbedCondition {
	Poor = 1,
	Acceptable = 2,
	Good = 3,
	VeryPoor = 4,
	VeryGood = 5,
}

export enum SeedRateMapOrigin {
	Calculated = 1,
	Drawn = 2,
}

export enum SeedRateUnit {
	Kg = 1,
	Tonnes = 2,
	Units = 11,
	Bags = 12,
	Seeds = 6,
	Plants = 13,
	Trays = 14,
	Seeds_1k = 15,
	Seeds_10k = 16,
	Seeds_1m = 17,
	Tubers = 18,
	Bulbs = 19,
}

export enum SlugPressure {
	High = 1,
	Medium = 2,
	Low = 3,
}

export enum WeedPressure {
	VeryHigh = 1,
	High = 2,
	Medium = 3,
	Low = 4,
}

